const maxLogoSlotWidthPx = 280;
const minAnimationDurationSec = 8;

export default function LogoCarousel() {
  const carousel = document.querySelectorAll<HTMLDivElement>(".js-logo-carousel");
  if (carousel && carousel.length > 0) {
    carousel.forEach((el: HTMLDivElement) => {
      if (el) {
        const autoplayBtn = el.querySelector<HTMLButtonElement>(".js-autoplay-btn");
        const trackWrapper = el.querySelector<HTMLDivElement>(".js-track-wrapper");
        const track = el.querySelector<HTMLDivElement>(".js-track");
        const scrollSpeedParse = el.getAttribute("data-scroll-speed");
        const scrollSpeed = scrollSpeedParse ? parseInt(scrollSpeedParse, 10) : 100;
        let items = el.querySelectorAll<HTMLDivElement>(".js-item");
        let isPaused = false;
        let isLoaded = true;

        const initTrack = () => {
          if (track && trackWrapper && items && items.length > 1) {
            const viewportWidth = window.innerWidth;
            const slidesToShow = viewportWidth > 1216 ? 5 : viewportWidth > 768 ? 4 : 3;
            const trackWidth = trackWrapper.offsetWidth;
            const itemWidth = Math.min(trackWidth / slidesToShow, viewportWidth <= 768 ? 172 : maxLogoSlotWidthPx);
            items = el.querySelectorAll<HTMLDivElement>(".js-item");
            items.forEach((item) => {
              item.style.width = `${itemWidth}px`;
            });
            track.style.animationDuration = `${Math.max(minAnimationDurationSec, ((items.length / 2) * itemWidth) / scrollSpeed)}s`;
            if (isLoaded) {
              track.style.animationPlayState = "running";
              isLoaded = false;
            }
          }
        };

        const debounce = (func: () => void, delay: number) => {
          let timeout: any;
          return function () {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
              func();
            }, delay);
          };
        };

        const debouncedInitTrack = debounce(initTrack, 200);

        if (track && items && items.length > 1) {
          items.forEach((item) => {
            const clone = item.cloneNode(true);
            track.appendChild(clone);
          });

          initTrack();
          window.addEventListener("resize", debouncedInitTrack);
        }

        if (trackWrapper && track && autoplayBtn) {
          trackWrapper.addEventListener("mouseenter", () => {
            if (!isPaused) {
              track.style.animationPlayState = "paused";
              autoplayBtn.setAttribute("data-mode", "paused");
            }
          });
          trackWrapper.addEventListener("mouseleave", () => {
            if (!isPaused) {
              track.style.animationPlayState = "running";
              autoplayBtn.setAttribute("data-mode", "playing");
            }
          });

          autoplayBtn.addEventListener("click", () => {
            isPaused = !isPaused;
            track.style.animationPlayState = isPaused ? "paused" : "running";
            autoplayBtn.setAttribute("data-mode", isPaused ? "paused" : "playing");
          });
        }
      }
    });
  }
}
